import { StringUtils } from "ts_utils";

export class LocalStorageHelper {

	private static _isNewUser:boolean = null;

	public static clearAllStoredSettings():void {
		if (localStorage != null){
			localStorage.clear();
		}
	}
	
	public static getStudentData():string {
		if (localStorage != null){
			return localStorage.getItem("students")?? null;
		}
		else {
			return null;
		}
	}
	
	public static saveStudentData(studentsJson:string):void {
		if (localStorage != null){
			localStorage.setItem('students', studentsJson);
		}
	}
	
	public static getShowFingerings():boolean {
		if (localStorage != null){
			if (localStorage.getItem('showFingerings') != null){
				return (localStorage.getItem('showFingerings') === 'true');
			}
			else {
				return true;
			}
		}
		else {
			return true;
		}
	}
	
	public static setShowFingerings(value:boolean):void {
		if (localStorage != null){
			localStorage.setItem('showFingerings', (value)? 'true' : 'false');
		}
	}
	
	public static getMicId():string {
		if (localStorage != null){
			if (localStorage.getItem('micId') != null){
				return localStorage.getItem('micId');
			}
			else {
				return null;
			}
		}
		else {
			return null;
		}
	}
	
	public static setMicId(id:string):void {
		if (localStorage != null){
			if (id == null){
				localStorage.removeItem('micId');
			}
			else {
				localStorage.setItem('micId', id);
			}
		}
	}
	
	public static getRecordDelay():number {
		if (window.localStorage){
			let delay = window.localStorage.getItem("recordDelay");
			if (StringUtils.isNullOrEmpty(delay)){
				return null;
			}
			else {
				try {
					return Number.parseFloat(delay);
				}
				catch {
					return null;
				}
			}
		}
		return null;
	}
	
	public static setRecordDelay(delay:number):void {
		if (window.localStorage){
			window.localStorage.setItem("recordDelay", delay.toString());
		}
	}
}